import { folderStore } from '../store/store';
import Folder from '../store/schema/Folder';
import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import { select } from 'satcheljs/lib/legacy';
import { ObservableMap } from 'mobx';

export interface FolderTableState {
    folderTable: ObservableMap<string, Folder>;
}

export let folderTableSelector = {
    folderTable: () => folderStore.folderTable,
};

/** Returns true if a folder is specified distinguished folder. */
export function isDistinguishedFolder(
    folder: Folder,
    distinguishedFolderId: DistinguishedFolderIdName
): boolean {
    // folder is null in search scenario
    return !!folder && folder.distinguishedFolderId == distinguishedFolderId;
}

/** Returns true if a folder is a subfolder of a specified distinguished folder. */
export function isSubFolderOfDistinguishedFolder(
    folder: Folder,
    distinguishedFolderId: DistinguishedFolderIdName,
    state?: FolderTableState
): boolean {
    // folder is null in search scenario
    const parentFolderId = !!folder && folder.ParentFolderId;

    if (!parentFolderId) {
        // The parentFolderId is null for root folder of the folder trees, which means it's not a subfolder
        return false;
    }

    let parentFolder: Folder = state.folderTable.get(parentFolderId.Id);
    while (parentFolder) {
        if (parentFolder.distinguishedFolderId == distinguishedFolderId) {
            return true;
        } else if (!parentFolder.ParentFolderId) {
            return false;
        }
        parentFolder = state.folderTable.get(parentFolder.ParentFolderId.Id);
    }

    return false;
}

export let isUnderDistinguishedFolder = select<FolderTableState>({
    folderTable: () => folderStore.folderTable,
})(isSubFolderOfDistinguishedFolder);

/** Returns true if a folder is a specified distinguished folder or is a subfolder of it.*/
export default select<FolderTableState>({
    folderTable: () => folderStore.folderTable,
})(function isFolderOrSubFolderOfDistinguishedFolder(
    folder: Folder,
    distinguishedFolderId: DistinguishedFolderIdName,
    state?: FolderTableState
): boolean {
    return (
        isDistinguishedFolder(folder, distinguishedFolderId) ||
        isUnderDistinguishedFolder(folder, distinguishedFolderId, state)
    );
});
